import React from 'react';

const TONE_BG = {
    blue: '#3B82F6',
    amber: '#F59E0B',
    green: '#10B981',
    red: '#EF4444',
    brand: '#1D2C7B',
    violet: '#8B5CF6',
    slate: '#64748B',
};

/** Compact metric tile used above list pages. */
export default function StatCard({ tone = 'brand', count, label, hint }) {
    return (
        <div className="flex min-w-0 items-center gap-3 rounded-xl border border-slate-200/90 bg-white px-3 py-2.5">
            <span
                className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg text-sm font-bold tabular-nums text-white"
                style={{ backgroundColor: TONE_BG[tone] ?? TONE_BG.brand }}
            >
                {count ?? 0}
            </span>
            <span className="min-w-0">
                <span className="block truncate text-sm font-semibold text-slate-800">{label}</span>
                {hint && <span className="mt-0.5 block truncate text-[11px] text-slate-400">{hint}</span>}
            </span>
        </div>
    );
}
